import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useRef, useState } from 'react';

import { DotsIcon, IcGoToMessageIcon, IcReplyIcon } from '@gem/icons';
import { IconButton } from '@gem/ui-kit';

import { disableQuoteAttrs } from '../../Message.constants';
import { MessageActionsMenu } from '../../MessageActionsMenu/MessageActionsMenu';
import Reactions from './Reactions';
import usePresenter from './presenter';
import styles from './styles.m.css';

export const MessageMenu = observer(({ message, messageViewPageType }) => {
  const { reactionsPopover, presenter } = usePresenter({
    message,
    messageViewPageType,
  });

  const buttonRef = useRef(null);

  const [popoverIsOpen, setPopoverIsOpen] = useState(false);

  const isOpened = popoverIsOpen || reactionsPopover.isOpened;

  const classes = classNames(styles.menuPlaceholder, 'message-menu', {
    [styles.opened]: isOpened,
    [styles.right]: !message.isLeftPosition,
  });

  const containerClasses = classNames(styles.itemContainer, {
    [styles.opened]: popoverIsOpen,
  });

  const placement = message.isLeftPosition ? 'right-start' : 'left-start';

  return (
    <div
      className={classes}
      {...disableQuoteAttrs}
    >
      {presenter.canBeReplied && (
        <IconButton
          Icon={IcReplyIcon}
          onClick={presenter.startReply}
          className={classNames(styles.itemContainer, styles.replyIcon)}
          dataTest="reply-button"
          theme="chat-average"
        />
      )}

      {presenter.messageCanBeFocused && (
        <IconButton
          Icon={IcGoToMessageIcon}
          onClick={presenter.goToMessage}
          className={styles.itemContainer}
          dataTest="reply-button"
          theme="chat-average"
        />
      )}
      {message.isAvailableReactions && (
        <Reactions
          message={message}
          popover={reactionsPopover}
        />
      )}
      {message.hasMenuItems && (
        <>
          <IconButton
            setRef={buttonRef}
            Icon={DotsIcon}
            className={containerClasses}
            dataTest="message-menu-button"
            theme="chat-average"
          />
          <MessageActionsMenu
            reference={buttonRef}
            placement={placement}
            message={message}
            messageViewPageType={messageViewPageType}
            onChange={setPopoverIsOpen}
          />
        </>
      )}
    </div>
  );
});
